<template>
    <PainelGrafico
        titulo="Produção Diária"
        v-model:aberto="mostrarGrafico"
        :carregando="carregando"
        :vazio="!carregando && !temDados"
        :dica="mes == null ? 'Clique em um mês para ver as semanas' : ''"
    >
        <template #info>
            <v-menu location="end">
                <template v-slot:activator="{ props }">
                    <i v-bind="props" class="bi bi-info-circle" title="Sobre o indicador"></i>
                </template>
                <v-card min-width="100" style="max-width: 23rem; padding: 1rem">
                    <div>
                        <b>Fórmula:</b> Quantidade de produtos acabados (exceto 'conjunto')
                        e etapa disponível / 22.<br>
                        <b>Polaridade:</b> Quanto maior, melhor.<br>
                        <b>Fonte:</b> OMIE > Produção > Produto acabado.<br>
                        <b>Descrição:</b> Média diária de produção no período.
                    </div>
                </v-card>
            </v-menu>
        </template>

        <template #filtros>
            <div>
                <label for="familia-producao">Família do produto</label>
                <select id="familia-producao" v-model="familiaSelecionada" @change="getDados()">
                    <option>Todos</option>
                    <option v-for="(i, index) in listaFamilias" :key="index">{{ i }}</option>
                </select>
            </div>
        </template>

        <Bar
            :options="dadosGrafico().options"
            :data="dadosGrafico().data"
            ref="barChart"
        />
    </PainelGrafico>
</template>

<script>
import serviceGraficos from '@/services/serviceGraficos.js';
import { Bar } from 'vue-chartjs';
import {
    Chart as ChartJS,
    Title,
    Tooltip,
    Legend,
    BarElement,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
} from 'chart.js';
import { getRelativePosition } from 'chart.js/helpers';
import PainelGrafico from '@/components/PainelGrafico.vue';
import { getChartTheme, baseChartOptions } from '@/utils/chartTheme';

ChartJS.register(
    Title,
    Tooltip,
    Legend,
    BarElement,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement
);

export default {
    name: 'ProduçãoDiaria',
    components: { Bar, PainelGrafico },
    props: {
        mes: { required: true },
        ano: { required: true },
    },
    emits: ['updateMes'],
    data() {
        return {
            data: null,
            mostrarGrafico: true,
            carregando: true,
            listaFamilias: [],
            familiaSelecionada: 'Todos',
        };
    },
    computed: {
        temDados() {
            return Boolean(this.data?.mediaDia?.length);
        },
    },
    watch: {
        mes: 'getDados',
        ano: 'getDados',
    },
    mounted() {
        this.getFamilias();
    },
    methods: {
        async getFamilias() {
            try {
                this.listaFamilias = await serviceGraficos.getFamilias();
                await this.getDados();
            } catch (error) {
                console.error('Erro ao obter familias:', error);
                this.carregando = false;
            }
        },
        async getDados() {
            this.carregando = true;
            try {
                this.data = await serviceGraficos.getProdução(
                    this.mes,
                    this.ano,
                    this.familiaSelecionada
                );
            } catch (error) {
                console.error('Erro ao obter dados:', error);
                this.data = null;
            } finally {
                this.carregando = false;
            }
        },
        dadosGrafico() {
            const theme = getChartTheme();
            const options = baseChartOptions({
                ...theme,
                onClick: (e) => {
                    if (this.mes != null || !this.$refs.barChart?.chart) return;
                    const canvasPosition = getRelativePosition(e, this.$refs.barChart.chart);
                    const dataX = this.$refs.barChart.chart.scales.x.getValueForPixel(canvasPosition.x);
                    if (dataX != null && dataX >= 0) {
                        this.$emit('updateMes', dataX + 1);
                    }
                },
            });

            return {
                data: {
                    datasets: [
                        {
                            label: 'Total',
                            hidden: true,
                            backgroundColor: '#d50000',
                            data: this.data?.total || [],
                        },
                        {
                            label: 'Produção diária',
                            backgroundColor: '#fc4b2a',
                            borderRadius: 4,
                            data: this.data?.mediaDia || [],
                        },
                    ],
                },
                options,
            };
        },
    },
};
</script>
